module.exports = __webpack_public_path__ + "img/scotland.295e9e00.svg";